import { render, staticRenderFns } from "./CustomerOnboardingDetailsView.vue?vue&type=template&id=9d45b1e8&scoped=true&"
import script from "./CustomerOnboardingDetailsView.vue?vue&type=script&lang=ts&"
export * from "./CustomerOnboardingDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOnboardingDetailsView.vue?vue&type=style&index=0&id=9d45b1e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d45b1e8",
  null
  
)

export default component.exports